import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import "../contextualhelp_vars.css";
import $jdkk1$contextualhelp_vars_cssmjs from "../contextualhelp_vars_css.mjs";
import {Popover as $3a473e3b7032f626$export$5b6b19405a83ff9d} from "../overlays/Popover.mjs";
import {SlotProvider as $62024859ff9f1f8a$export$8107b24b91795686} from "../utils/Slots.mjs";
import "../menu_vars.css";
import $jdkk1$menu_vars_cssmjs from "../menu_vars_css.mjs";
import {SubmenuTriggerContext as $9f4d05c8f96993f7$export$8d97fe02339fc0e3, useMenuStateContext as $9f4d05c8f96993f7$export$efa3856fc0e85e7f} from "./context.mjs";
import {TrayHeaderWrapper as $8cccdb0b63bfcdeb$export$3dfe97b5c32d8d8c} from "./Menu.mjs";
import {unwrapDOMRef as $3c2c983d5210446c$export$c7e28c72a4823176} from "../utils/useDOMRef.mjs";
import {useIsMobileDevice as $f357d4aae54bf1ff$export$736bf165441b18c7} from "../utils/useIsMobileDevice.mjs";
import {FocusScope as $jdkk1$FocusScope} from "react-aria/FocusScope";
import {getInteractionModality as $jdkk1$getInteractionModality} from "react-aria/private/interactions/useFocusVisible";
import {nodeContains as $jdkk1$nodeContains, isFocusWithin as $jdkk1$isFocusWithin} from "react-aria/private/utils/shadowdom/DOMFunctions";
import $jdkk1$react, {useRef as $jdkk1$useRef, useState as $jdkk1$useState, useEffect as $jdkk1$useEffect} from "react";
import $jdkk1$reactdom from "react-dom";
import {useSubmenuTrigger as $jdkk1$useSubmenuTrigger} from "react-aria/useMenu";
import {useSubmenuTriggerState as $jdkk1$useSubmenuTriggerState} from "react-stately/useMenuTriggerState";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 















function $761fad94f7cc567f$var$ContextualHelpTrigger(props) {
    let { isUnavailable: isUnavailable = false, targetKey: targetKey } = props;
    let triggerRef = (0, $jdkk1$useRef)(null);
    let popoverRef = (0, $jdkk1$useRef)(null);
    let { popoverContainer: popoverContainer, trayContainerRef: trayContainerRef, rootMenuTriggerState: rootMenuTriggerState, menu: parentMenuRef, state: state } = (0, $9f4d05c8f96993f7$export$efa3856fc0e85e7f)();
    let submenuTriggerState = (0, $jdkk1$useSubmenuTriggerState)({
        triggerKey: targetKey
    }, {
        ...rootMenuTriggerState,
        ...state
    });
    let submenuRef = (0, $3c2c983d5210446c$export$c7e28c72a4823176)(popoverRef);
    let { submenuTriggerProps: submenuTriggerProps, popoverProps: popoverProps } = (0, $jdkk1$useSubmenuTrigger)({
        parentMenuRef: parentMenuRef,
        submenuRef: submenuRef,
        type: 'dialog',
        isDisabled: !isUnavailable
    }, submenuTriggerState, triggerRef);
    let isMobile = (0, $f357d4aae54bf1ff$export$736bf165441b18c7)();
    let [traySubmenuAnimation, setTraySubmenuAnimation] = (0, $jdkk1$useState)('');
    (0, $jdkk1$useEffect)(()=>{
        if (submenuTriggerState.isOpen) setTraySubmenuAnimation('spectrum-TraySubmenu-enter');
    }, [
        submenuTriggerState.isOpen
    ]);
    let slots = {};
    if (isUnavailable) slots = {
        dialog: {
            UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jdkk1$contextualhelp_vars_cssmjs))), 'react-spectrum-ContextualHelp-dialog', {
                'react-spectrum-ContextualHelp-dialog--isMobile': isMobile
            }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jdkk1$menu_vars_cssmjs))), {
                'spectrum-Menu-subdialog': !isMobile,
                [traySubmenuAnimation]: isMobile
            }))
        },
        content: {
            UNSAFE_className: (0, ($parcel$interopDefault($jdkk1$contextualhelp_vars_cssmjs)))['react-spectrum-ContextualHelp-content']
        },
        footer: {
            UNSAFE_className: (0, ($parcel$interopDefault($jdkk1$contextualhelp_vars_cssmjs)))['react-spectrum-ContextualHelp-footer']
        }
    };
    let [trigger] = (0, $jdkk1$react).Children.toArray(props.children);
    let [, content] = props.children;
    let onBlurWithin = (e)=>{
        if (e.relatedTarget && popoverRef.current && !(0, $jdkk1$nodeContains)(popoverRef.current.UNSAFE_getDOMNode(), e.relatedTarget) && !(e.relatedTarget === triggerRef.current && (0, $jdkk1$getInteractionModality)() === 'pointer')) {
            if (submenuTriggerState.isOpen) submenuTriggerState.close();
        }
    };
    let overlay;
    let tray;
    let onBackButtonPress = ()=>{
        setTraySubmenuAnimation('spectrum-TraySubmenu-exit');
        setTimeout(()=>{
            submenuTriggerState.close();
            if (parentMenuRef.current && !(0, $jdkk1$isFocusWithin)(parentMenuRef.current)) parentMenuRef.current.focus();
        }, 220); // Matches transition duration
    };
    if (isMobile) {
        delete submenuTriggerProps.onBlur;
        delete submenuTriggerProps.onHoverChange;
        if (trayContainerRef.current && submenuTriggerState.isOpen) {
            let subDialogKeyDown = (e)=>{
                switch(e.key){
                    case 'Escape':
                        e.stopPropagation();
                        onBackButtonPress();
                        break;
                }
            };
            tray = /*#__PURE__*/ (0, $jdkk1$react).createElement((0, $8cccdb0b63bfcdeb$export$3dfe97b5c32d8d8c), {
                isSubmenu: true,
                parentMenuTreeState: state,
                rootMenuTriggerState: rootMenuTriggerState,
                wrapperKeyDown: subDialogKeyDown,
                onBackButtonPress: onBackButtonPress
            }, content);
            overlay = /*#__PURE__*/ (0, $jdkk1$reactdom).createPortal(tray, trayContainerRef.current);
        }
    } else {
        let onDismissButtonPress = ()=>{
            submenuTriggerState.close();
            parentMenuRef.current?.focus();
        };
        overlay = /*#__PURE__*/ (0, $jdkk1$react).createElement((0, $3a473e3b7032f626$export$5b6b19405a83ff9d), {
            ...popoverProps,
            UNSAFE_style: {
                clipPath: 'unset',
                overflow: 'visible',
                filter: 'unset',
                borderWidth: '0px'
            },
            UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jdkk1$menu_vars_cssmjs))), 'spectrum-Submenu-popover'),
            onDismissButtonPress: onDismissButtonPress,
            onBlurWithin: onBlurWithin,
            container: popoverContainer,
            state: submenuTriggerState,
            ref: popoverRef,
            triggerRef: triggerRef,
            placement: "end top",
            containerPadding: 0,
            hideArrow: true,
            enableBothDismissButtons: true
        }, /*#__PURE__*/ (0, $jdkk1$react).createElement((0, $jdkk1$FocusScope), {
            restoreFocus: true,
            contain: true
        }, content));
    }
    return /*#__PURE__*/ (0, $jdkk1$react).createElement((0, $jdkk1$react).Fragment, null, /*#__PURE__*/ (0, $jdkk1$react).createElement((0, $9f4d05c8f96993f7$export$8d97fe02339fc0e3).Provider, {
        value: {
            isUnavailable: isUnavailable,
            triggerRef: triggerRef,
            ...submenuTriggerProps
        }
    }, trigger), /*#__PURE__*/ (0, $jdkk1$react).createElement((0, $62024859ff9f1f8a$export$8107b24b91795686), {
        slots: slots
    }, submenuTriggerState.isOpen && overlay));
}
$761fad94f7cc567f$var$ContextualHelpTrigger.getCollectionNode = function* getCollectionNode(props) {
    let childArray = [];
    (0, $jdkk1$react).Children.forEach(props.children, (child)=>{
        if (/*#__PURE__*/ (0, $jdkk1$react).isValidElement(child)) childArray.push(child);
    });
    let [trigger] = childArray;
    let [, content] = props.children;
    yield {
        element: /*#__PURE__*/ (0, $jdkk1$react).cloneElement(trigger, {
            ...trigger.props,
            hasChildItems: true,
            isTrigger: true
        }),
        wrapper: (element)=>/*#__PURE__*/ (0, $jdkk1$react).createElement($761fad94f7cc567f$var$ContextualHelpTrigger, {
                key: element.key,
                targetKey: element.key,
                ...props
            }, element, content)
    };
};
let $761fad94f7cc567f$export$5413b169fff83e61 = $761fad94f7cc567f$var$ContextualHelpTrigger;


export {$761fad94f7cc567f$export$5413b169fff83e61 as ContextualHelpTrigger};
//# sourceMappingURL=ContextualHelpTrigger.mjs.map
